import { graphql } from "gql/gql";
import { request } from "graphql-request";

import { BACKEND_DOMAIN } from "utils/constants";
import {
    buildBuildingModelRequestVariables,
    buildRequestHeaders,
} from "utils/helpers";

const queryFn = (
    accessToken: string,
    buildingModelUid: string,
    utilityData: UtilityData[]
) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: {
            ...buildBuildingModelRequestVariables(buildingModelUid),
            utilityData,
        },
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data) => {
        if (data.submitUtilityData.error) {
            const error = new Error(data.submitUtilityData.error);
            (error as any).response = {
                errors: [
                    {
                        errorCode: "CALIBRATION_ERROR",
                        description: data.submitUtilityData.error,
                        message: data.submitUtilityData.error,
                    },
                ],
            };
            throw error;
        }
        return data.submitUtilityData.buildingModelRunUid;
    });

const query = graphql(`
    mutation submitUtilityData(
        $buildingModelUid: Uuid!
        $utilityData: [UtilityData!]!
    ) {
        submitUtilityData(
            buildingModelUid: $buildingModelUid
            utilityData: $utilityData
        ) {
            error
            buildingModelRunUid
        }
    }
`);

export default queryFn;
